import { Box, type SxProps, type Theme } from '@mui/material';

export const PRECEON_GRADIENT = 'linear-gradient(90deg, #443247 0%, #DE0043 100%)';
/** Solid end of the gradient, used to tint the card border of a Preceon-only monitoring. */
export const PRECEON_COLOR = '#DE0043';

/** Preceon brand distinctive, shown next to a hybrid name (CUL-1505 AC4). */
const PreceonBadge = ({ sx }: { sx?: SxProps<Theme> }) => (
    <Box
        component='span'
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            py: 0.5,
            px: 2,
            fontSize: 14,
            fontWeight: 700,
            color: 'white !important',
            borderRadius: '8px 0 0 8px',
            background: PRECEON_GRADIENT,
            whiteSpace: 'nowrap',
            ...sx,
        }}
    >
        PRECEON
    </Box>
);

export default PreceonBadge;
